import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { flattenDeep } from "lodash";
import { Link, List, ListItem, Button } from "@material-ui/core";
import LinkIcon from "@mui/icons-material/Link";
import useCacheDataMainTask from "hooks/useCacheDataMainTask";
import { getLinkTabPart } from "actions/taskDetail/taskDetailActions";
import { normalizeUrl } from "helpers/jobDetail/stringHelper";
import Collapse from "./Collapse";

const LinkBox = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const project = useSelector(
    (state) => state.project.detailProject.data.project
  );
  const taskId = useSelector(
    (state) => state.taskDetail.detailTask.taskDetails.id
  );
  const totalLink = useSelector(
    (state) => state.taskDetail.detailTask.taskDetails.total_link
  );
  const links = useCacheDataMainTask("taskDetail.media.detailLink", []);

  useEffect(() => {
    if (taskId && taskId === project?.main_task) {
      dispatch(getLinkTabPart({ taskId }));
    }
  }, [dispatch, taskId, totalLink, project]);

  return (
    <Collapse
      classes="listPartTabBody--media listPartTabBody--links"
      label={t("LABEL_CHAT_TASK_LINK")}
    >
      {links.length > 0 ? (
        <>
          <List>
            {flattenDeep(links.map((item) => item.links))
              .reverse()
              .slice(0, 3)
              .map((item) => {
                return (
                  <Link
                    href={normalizeUrl(item.url)}
                    target="_blank"
                    key={item.id}
                  >
                    <ListItem disableGutters button className="linkBoxItem">
                      <LinkIcon className="linkBoxItem--icon" />
                      <div className="linkBoxItem--content">
                        <div className="linkBoxItem--url">
                          {normalizeUrl(item.url)}
                        </div>
                        <div className="linkBoxItem--bottom">
                          <span className="linkBoxItem--domain">
                            {new URL(normalizeUrl(item.url)).hostname}
                          </span>
                          <span>
                            {moment(item.date_create, "DD/MM/YYYY").format(
                              "DD/MM"
                            )}
                          </span>
                        </div>
                      </div>
                    </ListItem>
                  </Link>
                );
              })}
          </List>
          <div className="btn-bottom">
            <Button
              fullWidth
              variant="contained"
              onClick={() => {
                props.setDefaultMediaTab(2);
                props.setShow(4);
              }}
            >
              {t("LABEL_CHAT_TASK_BTN_VIEW_ALL")}
            </Button>
          </div>
        </>
      ) : (
        <div className="listPartTabBody--msg_empty_data">
          {t("LABEL_CHAT_TASK_EMPTY_LINK")}
        </div>
      )}
    </Collapse>
  );
};

export default LinkBox;
